module.exports = __webpack_public_path__ + "img/89.371e3477.png";